// =============================================
// FILE: src/components/ForgotPassword.jsx
// Purpose: Use your existing HTTP function mapped at
//   /api/auth/sendReset  -> authAdminSendReset (us-central1)
// from firebase.json rewrites. No Firebase default email.
// =============================================

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setMsg("");
    const trimmed = (email || "").trim();
    if (!trimmed) { setErr("Please enter your email."); return; }

    setBusy(true);
    try {
      // Call your existing Cloud Function via Hosting rewrite
      // It should: generate Firebase reset link to /reset-password and send via SendGrid
      const res = await fetch("/api/auth/sendReset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmed, url: window.location.origin })
      });

      if (!res.ok) throw new Error("Failed to send reset email");
      const data = await res.json().catch(() => ({}));
      if (data?.error) throw new Error(data.error);

      setMsg("Password reset email sent. Please check your inbox.");
    } catch (e2) {
      setErr(e2?.message || "Failed to send reset email.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f6f7fb", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 16px", fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <div style={{ width: "100%", maxWidth: 420, background: "#fff", borderRadius: 20, boxShadow: "0 10px 40px rgba(42,5,22,0.10)", border: "1px solid #e8ebf3", overflow: "hidden" }}>
        <div style={{ background: "#650202", padding: "18px 24px", textAlign: "center" }}>
          <img src="/Lastwishbox-logo.png" alt="LastWish Box" style={{ height: 34, width: "auto", filter: "brightness(0) invert(1)", marginBottom: 10 }} />
          <h2 style={{ margin: 0, color: "#fff", fontSize: 18, fontWeight: 800 }}>Reset your password</h2>
          <p style={{ margin: "8px 0 0", color: "rgba(255,255,255,0.75)", fontSize: 14, lineHeight: 1.5 }}>Enter your email and we'll send you a secure link to reset your password.</p>
        </div>
        <div style={{ padding: "24px 28px 28px" }}>
          <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#657899", marginBottom: 6 }}>Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", height: 44, padding: "0 14px", borderRadius: 10, border: "1px solid #e8ebf3", fontSize: 15, boxSizing: "border-box", marginBottom: 12 }}
          />
          {err && <div style={{ color: "#a00", marginBottom: 10, fontSize: 13 }}>{err}</div>}
          {msg && <div style={{ color: "#0a7e28", marginBottom: 10, fontSize: 13 }}>{msg}</div>}
          <button onClick={submit} disabled={busy} style={{ width: "100%", height: 48, borderRadius: 12, border: "none", background: "#f15822", color: "#fff", fontWeight: 800, fontSize: 15, cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.7 : 1, marginBottom: 12 }}>
            {busy ? "Sending..." : "Send reset link"}
          </button>
          <button onClick={() => navigate("/login")} style={{ width: "100%", height: 44, borderRadius: 12, border: "1px solid #e8ebf3", background: "#fff", color: "#650202", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
            Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}
